import React from 'react';
import {
  Container, Grid, Icon,
} from 'semantic-ui-react';

const Loading = () => (
  <Container className="container-margins">
    <Grid>
      <Grid.Row>
        <Grid.Column width={3} />
        <Grid.Column textAlign="center" width={10}>
          <Icon.Group size="large">
            <Icon color="teal" loading size="huge" name="spinner" />
            <Icon color="teal" size="large" name="medkit" />
          </Icon.Group>
        </Grid.Column>
        <Grid.Column width={3} />
      </Grid.Row>
    </Grid>
  </Container>
);

Loading.propTypes = {
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js